import SearchIcon from '@mui/icons-material/Search';
import {
  InputAdornment,
  OutlinedInput,
  Toolbar
} from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

const StyledRoot = styled(Toolbar)(({ theme }) => ({
  height: 96,
  display: 'flex',
  justifyContent: 'space-between',
  padding: theme.spacing(0, 1, 0, 3),
  marginLeft: 'auto',
}));

const StyledSearch = styled(OutlinedInput)(({ theme }) => ({
  width: 320,

  '& fieldset': {
    borderWidth: `1px !important`,
    borderColor: `${alpha(theme.palette.grey[500], 0.32)} !important`,
  },
}));

export default function LogsToolbar({
  filterName,
  onFilterName,
}) {

  return (
    <Toolbar>
      <StyledRoot>
        <StyledSearch
          value={filterName}
          onChange={onFilterName}
          placeholder="Search..."
          startAdornment={
            <InputAdornment position="start">
              <SearchIcon fontSize="medium" />
            </InputAdornment>
          }
        />
      </StyledRoot>
    </Toolbar>
  );
}
